
import { Component, Vue } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { ProductService, ProductDto, ProductCategoryService } from "@/api/service-proxies";
import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";
import phoneDialog from "../components/preViewPhoneDialog.vue"
class TenantPagedRequest extends PagedRequestDto {
  name!: string;
  productCategoryId!: string;
  createTime!: moment.Moment;
  createTime2!: moment.Moment;
}

@Component({
  name: "Tenant",
  components: {
    Pagination, phoneDialog


  }
})
export default class Tenant extends PagedListBase<
  TenantPagedRequest,
  ProductDto
> {
  request = new TenantPagedRequest();
  productService = new ProductService();
  productCategoryService: ProductCategoryService = new ProductCategoryService();
  options = [{
    value: 0,
    label: '待上架'
  }, {
    value: 1,
    label: '售卖中'
  }, {
    value: 2,
    label: '已断货'
  }, {
    value: 3,
    label: '已下架'
  }]
  value = null
  productCategoryType: any = [];
  pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  value1 = ''
  value2 = ''
  created() {
    this.refresh();
    this.initProductCategory();
  }

  getpage(finishCallback: Function): void {
    this.productService
      .getAll(
        this.request.name,
        this.request.productCategoryId,
        this.request.createTime,
        this.request.createTime2,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        result.items.forEach(e=>{
          e.p_Path = (this as any).$aes.imgAddAuth(e.p_Path)
        })
        this.list = result.items;
        this.showPaging(result);
      })
      .finally(() => {
        finishCallback();
      });
  }
  handleCreate() {
    this.$router.push({ path: "/product/product/create" });
  }
  handleUpdate(product: ProductDto) {
    this.$router.push({ path: `/product/product/update/${product.id}` });
  }
  handleDelete(product: ProductDto) {
    this.$confirm("确定删除产品?")
      .then(async () => {
        await this.productService.delete(product.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }
  openPhoneDialog(row) {
    (this.$refs.phoneDialogRef as phoneDialog).open(row)
  }
  //状态改变事件
  statusSwitchChange(product: ProductDto) {

    this.productService.productSwitchChange(product);

  }

  //获取商品分类的数据
  initProductCategory() {
    var _that = this;
    this.productCategoryService.getAllProductCategory().then(res => {
      _that.productCategoryType = res;
    });


  }

  dateTimeChange(event: any) {
    if (event) {
      this.request.createTime = event[0];
      this.request.createTime2 = event[1];
    } else {
      this.request.createTime = null;
      this.request.createTime2 = null;
    }
  }
}
